module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "dash"
    }
  }, [_c('div', {
    staticClass: "row",
    attrs: {
      "id": "dash_header"
    }
  }, [_c('div', {
    staticClass: "span_12"
  }, [_c('div', {
    staticClass: "row justify_end",
    attrs: {
      "id": "horizontal_nav"
    }
  }, [_c('a', {
    attrs: {
      "href": "http://www.ncadv.org",
      "target": "_blank"
    }
  }, [_vm._v("About NCADV")]), _vm._v(" "), _c('a', {
    attrs: {
      "href": "https://app.discoveryeducation.com/public:session/login",
      "target": "_blank"
    }
  }, [_vm._v("Connect")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/resources"
    }
  }, [_vm._v("Resources")])], 1)])]), _vm._v(" "), (_vm.intro) ? _c('div', {
    staticClass: "row align_center",
    style: ({
      backgroundImage: 'url(' + _vm.intro.image.fields.file.url + ')'
    }),
    attrs: {
      "id": "dash_hero"
    }
  }, [_c('div', {
    staticClass: "dash_hero_content span_8_sm span_6_lg offset_2_xs"
  }, [_c('h1', {
    staticClass: "dash_hero_title"
  }, [_vm._v(_vm._s(_vm.intro.header))]), _vm._v(" "), _c('h3', {
    staticClass: "dash_hero_tagline"
  }, [_vm._v(_vm._s(_vm.intro.tagline))]), _vm._v(" "), _c('img', {
    attrs: {
      "src": _vm.intro.image.fields.file.url,
      "hidden": ""
    }
  })])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "span_10_sm offset_2_sm span_8_lg"
  }, [_c('router-view')], 1)]), _vm._v(" "), _c('div', {
    attrs: {
      "id": "side_nav"
    }
  }, [_c('div', {
    attrs: {
      "id": "nav_logo"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('img', {
    attrs: {
      "src": "/static/img/ncadv_logo.png"
    }
  })])], 1), _vm._v(" "), _c('ul', {
    attrs: {
      "id": "side_nav_list"
    }
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_vm._v("Curriculum")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/resources"
    }
  }, [_vm._v("Resources")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/orgs"
    }
  }, [_vm._v("Get Help")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": "/credits"
    }
  }, [_vm._v("Credits")])], 1)]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "gate",
      "appear": ""
    }
  }, [(_vm.gate_active) ? _c('gate', {
    attrs: {
      "gate_active": _vm.gate_active
    },
    on: {
      "closegate": function($event) {
        _vm.gate_active = false
      }
    }
  }) : _vm._e()], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-57c35e4a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./src/components/dashboard/dashboard.html
// module id = 621
// module chunks = 1